import React from 'react';

export const RgHuyen = (props) => {
    const ShowEdit = () => {
        props.showEditThongTin();
    }
    return (
        <div className="thong-tin">
            {
                props.thongTin.tenHuyen ? <table className="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th colSpan="2"> Ranh giới huyện
                            {
                                    props.admin ? <button type="button" className="btn btn-primary btn-sm suathongtin" onClick={ShowEdit}><i className='fas fa-edit'></i></button> : ''
                                }
                            </th>
                        </tr>
                        <tr>
                            <th className="col-name">Tên</th>
                            <th>Thông tin</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="col-name">Tỉnh</td>
                            <td>{props.thongTin?.tenTinh}</td>
                        </tr>
                        <tr>
                            <td className="col-name">Huyện</td>
                            <td>{props.thongTin?.tenHuyen}</td>
                        </tr>                      
                    </tbody>
                </table> : <h5 className="text-center">Không có thông tin</h5>
            }
        </div>
    )
};